import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {Observable} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {Select, Store} from '@ngxs/store';
import {Emittable, Emitter} from "@ngxs-labs/emitter";
import {OverlayPanel} from "primeng/overlaypanel";
import {FrontendTheming} from 'frontend-data-api/model/models';
import {DataState} from "../../../store/data.state";
import {isActivationKey} from '../../utils/keyboard.util';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent {
  @Input() additionText: boolean = false;
  @Emitter(DataState.saveLanguage)
  private saveLanguage!: Emittable<string>;
  @Select((state: any) => state.whitebricks.configuration?.theming)
  public readonly theming$!: Observable<FrontendTheming>;
  @Select((state: any) => state.whitebricks.configuration.merchantDetail.merchantName!)
  public merchantName$!: Observable<string>;
  @Select((state: any) => state.whitebricks.configuration.merchantDetail.logoUrl)
  public merchantLogo$!: Observable<string>;
  @Select((state: any) => state.whitebricks.flowProperties.properties!['merchant_redirect_url'])
  public merchantUrl$!: Observable<string>;
  @Select((state: any) => state.whitebricks.language)
  public language$!: Observable<string>;
  @Select(DataState.merchantShoppingCartRedirectUrl)
  public merchantShoppingCartRedirectUrl$!: Observable<string>;
  public languages: Array<string> = [];

  constructor(private readonly translateService: TranslateService, private readonly store: Store) {
    const lang = this.store.selectSnapshot((state: any) => state.whitebricks.language);
    this.languages = this.filterOptions(lang);
  }

  private filterOptions(selectedLanguage: string) {
    return this.translateService.getLangs().filter(value => value !== selectedLanguage);
  }

  public navigateToMerchant(url: string): void {
    window.open(url, '_self');
  }

  changeLanguage(lang: string, op: OverlayPanel) {
    this.translateService.use(lang);
    this.saveLanguage.emit(lang);
    op.hide();
    this.languages = this.filterOptions(lang);
  }

  public onLanguageKeydown(event: KeyboardEvent, lang: string, op: OverlayPanel): void {
    if (!isActivationKey(event)) {
      return;
    }
    event.preventDefault();
    this.changeLanguage(lang, op);
  }
}
